import { render } from "./ManifestDashboardMenu.vue?vue&type=template&id=6e31be93&scoped=true"
import script from "./ManifestDashboardMenu.vue?vue&type=script&lang=js"
export * from "./ManifestDashboardMenu.vue?vue&type=script&lang=js"

import "./ManifestDashboardMenu.vue?vue&type=style&index=0&id=6e31be93&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e31be93"]])

export default __exports__